/* NM Studio mobile first-purchase fixes (T-20261006-052).
   W2: on personalizable products, Add to Cart waits for a saved design.
   W3: the Printify editor only posts back {personalizationId, imageUrl}, never the typed text, so the
   saved preview image rides along as a hidden line-item property and is shown on the page and in the cart. */
(() => {
  const PID = 'properties[Personalization ID]';
  const PREV = 'properties[_Design preview]';
  const btn = () => document.querySelector('[id^="personalize-button-"]');
  if (!btn()) return;
  const forms = () => [...document.querySelectorAll('form[action*="/cart/add"]')];
  const has = () => forms().some((f) => f.querySelector(`input[name="${PID}"]`));
  let note, proof, preview = null;

  const renderProof = () => {
    const b = btn();
    if (!b) return;
    const show = has() && preview;
    if (!proof) { proof = document.createElement('div'); proof.className = 'nm-design-proof'; b.insertAdjacentElement('afterend', proof); }
    proof.hidden = !show;
    if (show && proof.dataset.src !== preview) {
      proof.dataset.src = preview;
      proof.textContent = '';
      const img = new Image(120, 120); img.src = preview; img.alt = 'Your saved design';
      const s = document.createElement('span'); s.textContent = 'Your saved design preview';
      proof.append(img, s);
    }
  };
  const sync = () => {
    const h = has();
    document.documentElement.classList.toggle('nm-needs-design', !h);
    if (h && note) note.hidden = true;
    if (!h) { preview = null; forms().forEach((f) => f.querySelectorAll(`input[name="${PREV}"]`).forEach((i) => i.remove())); }
    renderProof();
  };
  const nudge = () => {
    const b = btn();
    if (!b) return;
    if (!note) {
      note = document.createElement('p'); note.className = 'nm-design-required'; note.setAttribute('role', 'alert');
      note.textContent = 'Please add your personalized design first: tap "Add personalized design", fill in your text, and save.';
      b.insertAdjacentElement('afterend', note);
    }
    note.hidden = false;
    b.scrollIntoView({ behavior: 'smooth', block: 'center' });
    b.classList.add('nm-pulse'); setTimeout(() => b.classList.remove('nm-pulse'), 1600);
  };
  const block = (e) => { if (has()) return; e.preventDefault(); e.stopImmediatePropagation(); nudge(); };

  document.addEventListener('submit', (e) => { const f = e.target; if (f instanceof HTMLFormElement && f.action.includes('/cart/add')) block(e); }, true);
  document.addEventListener('click', (e) => {
    const t = e.target.closest && e.target.closest('[ref="addToCartButton"], .add-to-cart-button, button[name="add"], sticky-add-to-cart button, .sticky-add-to-cart__button');
    if (t) block(e);
  }, true);
  window.addEventListener('message', (e) => {
    const d = e.data;
    if (!d || d.type !== 'PERSONALIZATION_APPLIED' || !d.data || !d.data.imageUrl) return;
    setTimeout(() => {
      preview = d.data.imageUrl;
      forms().forEach((f) => {
        f.querySelectorAll(`input[name="${PREV}"]`).forEach((i) => i.remove());
        if (!f.querySelector(`input[name="${PID}"]`)) return;
        const i = document.createElement('input'); i.type = 'hidden'; i.name = PREV; i.value = preview; f.appendChild(i);
      });
      sync();
    }, 50);
  });
  const mo = new MutationObserver(() => sync());
  forms().forEach((f) => mo.observe(f, { childList: true, subtree: true }));
  sync();
})();
